import styled from "styled-components";

export const Container = styled.div`
  padding: 0px;
`;

export const IntroBox = styled.div`
  max-width: 1128px;
  margin: auto;

  padding: 80px 0 10px;
  display: flex;
  flex-direction: row;
  align-items: center;

  @media (max-width: 1100px) {
    margin: 0px 30px;
    flex-direction: column-reverse;
    padding: 30px 0 10px;
  }
  @media (max-width: 768px) {
    margin: 10px 10px;
  }
`;

export const IntroLeft = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  & > h1 {
    color: var(--secondary);
    font-size: 3rem;
    font-weight: bold;
    text-align: center;

    @media (max-width: 768px) {
      font-size: 2.2rem;
    }
  }
  & > h2 {
    padding-top: 20px;
    padding-bottom: 20px;
    color: var(--secondary);
    font-size: 1.7rem;
    text-align: center;

    @media (max-width: 768px) {
      font-size: 1.3rem;
      padding-top: 10px;
      padding-bottom: 10px;
    }
  }
`;

export const IntroRight = styled.div`
  width: auto;

  & > img {
    margin-left: auto;
    height: 20rem;
    padding: 60px;

    @media (max-width: 768px) {
      display: flex;
      height: 20rem;
    }
  }
`;

export const SocialIconsRow = styled.div`
  margin-top: 30px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

export const SocialIcon = styled.a`
  margin-right: 12px;
  border: 0.15rem solid var(--secondary);
  border-radius: 50%;
  &:hover {
    transition: all 0.3s ease-out;
    background-color: var(--hoverback);
    color: var(--secondary);
    border: 0.15rem solid var(--primary);
  }
  & > img {
    padding: 9px 10px;
    height: 25px;
    width: 25px;
  }
`;
